import { type DefaultOptions, QueryClient } from '@tanstack/react-query'

const queryConfig: DefaultOptions = {
  queries: {
    staleTime: 5 * 60 * 1000, // 5 minutos
    gcTime: 10 * 60 * 1000, // 10 minutos (antes era cacheTime)
    refetchOnWindowFocus: false,
    retry: 1,
    refetchOnReconnect: true,
  },
  mutations: {
    retry: 0,
    // Escritas falham sem conexão; não ficam enfileiradas para envio ao reconectar.
    networkMode: 'always',
  },
}

export const queryClient = new QueryClient({
  defaultOptions: queryConfig,
})
